export function hideGlobalNav(isFullContent: boolean): void {
  const isHonda = process.env.REACT_APP_THEME === 'honda';
  const navBarElement = document.getElementsByClassName(
    isHonda ? 'm_globalNav' : 'js-acr-nav'
  ) as HTMLCollectionOf<HTMLElement>;

  if (navBarElement.length) {
    navBarElement[0].style.transition = 'transform .5s';
    navBarElement[0].style.transform = isFullContent ? 'translateY(-100%)' : '';
  }
}

export function removeMinHeight() {
  const root = document.getElementById('root');

  root && (root.style.minHeight = '0');
}

export function resetMinHeight() {
  const root = document.getElementById('root');

  root && (root.style.minHeight = '');
}
